<div *ngIf="!isLoading">
    <div class="d-flex align-items-center">
        <div class="w-100">
            <app-searchbar [(value)]="filter" (valueChange)="applyFilter($event)"></app-searchbar>
        </div>
        <div class="d-flex nowrap">
            <button
                type="button"
                class="button m-l-2"
                [disabled]="selectedInvoiceProjectIds.size === 0"
                (click)="openSelectedProjectsInvoiceDialog()">
                Create invoice for selected ({{ selectedInvoiceProjectIds.size }})
            </button>
            <span ngbDropdown class="dropdown m-l-2">
                <button ngbDropdownToggle class="button button--select">
                    Options
                </button>
                <span ngbDropdownMenu class="dropdown-menu-right">
                    <form>
                        <label ngbDropdownItem *appIsPermitted="{
                                module: 'TIMESHEETS',
                                operator: 'AND',
                                actions: ['EDIT']
                            }" (click)="sendReminders()">Send reminders</label>
                        <label ngbDropdownItem *appIsPermitted="{
                                module: 'TIMESHEETS',
                                operator: 'AND',
                                actions: ['READ']
                            }" (click)="openCronjobSettings()">Reminder settings</label>
                        <label ngbDropdownItem (click)="addNewTimesheet()" *appIsPermitted="{
                                module: 'TIMESHEETS',
                                operator: 'AND',
                                actions: ['CREATE']
                            }">Add a Timesheet</label>
                    </form>
                </span>
            </span>
            <!-- Reports toggle (duplicate of By employee's Reports) -->
                <span ngbDropdown class="dropdown m-l-2">
                <button ngbDropdownToggle class="button">
                    <i class="las la-chart-pie" style="margin-right:6px;"></i>
                    Reports
                </button>
                <span ngbDropdownMenu class="dropdown-menu-right">
                    <label ngbDropdownItem (click)="openReportsModal('departments')">Afdelingenrapportage</label>
                    <label ngbDropdownItem (click)="openReportsModal('overtime')">Rapport overuren</label>
                    <label ngbDropdownItem (click)="openReportsModal('billed')">billed hours by departement</label>
                </span>
            </span>
            <app-global-export-csv [componentName]="this.constructor.name" [exporter]="exporter"
                class="m-l-2"></app-global-export-csv>
        </div>
    </div>

    <div class="m-t-4">
        <div *ngIf="showOnlyDoneTimesheets && mixedStatusProjectNames.length > 0" class="verified-timesheets-warning m-b-2">
            Sommige projecten hebben zowel geverifieerde als niet-geverifieerde regels. Enkel DONE-regels worden getoond voor: {{ mixedStatusProjectNames.join(', ') }}.
        </div>
        <div *ngIf="employeesWithoutBudget.length > 0" class="missing-budget-warning m-b-2" [title]="getEmployeesWithoutBudgetTooltip()">
            <div class="missing-budget-warning__content">
                <i class="las la-exclamation-triangle missing-budget-warning__icon"></i>
                <span>
                    <strong>{{ employeesWithoutBudget.length }}</strong>
                    {{ employeesWithoutBudget.length === 1 ? 'actief personeelslid heeft' : 'actieve personeelsleden hebben' }}
                    geen budget voor deze maand.
                </span>
            </div>
            <a class="missing-budget-warning__button" routerLink="/budget/overview">
                <i class="las la-plus-circle"></i> Budget toewijzen
            </a>
        </div>
        <div class="table__overflow">
            <ng-container *ngFor="let dept of departments">
                <ng-container *ngIf="projectsForDepartment(dept.key)?.length">
                    <h3 class="m-t-3">{{ dept.label }}</h3>
                    <table mat-table class="fixed-table" [dataSource]="dataSourcesByDept[dept.key]" matSort>
                        <ng-container matColumnDef="select">
                            <th mat-header-cell class="col-select" *matHeaderCellDef></th>
                            <td mat-cell class="col-select" *matCellDef="let project">
                                <input
                                    type="checkbox"
                                    [checked]="isProjectSelectedForInvoice(project)"
                                    (click)="$event.stopPropagation()"
                                    (change)="toggleProjectForInvoice(project, $event.target.checked)"
                                    title="Selecteer dit project voor een gezamenlijke SES-factuur">
                            </td>
                            <td mat-footer-cell class="col-select dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="projects">
                            <th mat-header-cell class="col-projects" *matHeaderCellDef mat-sort-header>Projects</th>
                            <td mat-cell class="col-projects" *matCellDef="let project"><app-pill-project [project]="project"></app-pill-project></td>
                            <td mat-footer-cell class="col-projects dept-footer" *matFooterCellDef><strong>Totaal {{ dept.label }}</strong></td>
                        </ng-container>

                        <ng-container matColumnDef="invoiceReadiness">
                            <th mat-header-cell class="col-readiness" *matHeaderCellDef>Ready</th>
                            <td mat-cell class="col-readiness" *matCellDef="let project">
                                <div class="ready-line" *ngIf="getReadyToInvoiceStagesForProject(project) as stages">
                                    <span
                                        class="ready-dot"
                                        *ngFor="let stage of stages"
                                        [class.ready-dot--ok]="stage.passed"
                                        [class.ready-dot--fail]="!stage.passed"
                                        [ngbTooltip]="readyStageTip"
                                        [attr.aria-label]="getReadyStageTooltipLabel(stage)"
                                        [title]="getReadyStageTooltipLabel(stage)"
                                        container="body"
                                        placement="top"
                                        tabindex="0">
                                        <i class="las" [class.la-check]="stage.passed" [class.la-times]="!stage.passed"></i>
                                        <ng-template #readyStageTip>
                                            <div class="ready-tooltip">
                                                <div class="ready-tooltip__title">{{ stage.key }}. {{ stage.label }}</div>
                                                <div
                                                    class="ready-tooltip__state"
                                                    [class.ready-tooltip__state--ok]="stage.passed"
                                                    [class.ready-tooltip__state--fail]="!stage.passed">
                                                    {{ stage.passed ? 'In orde' : 'Niet in orde' }}
                                                </div>
                                                <div class="ready-tooltip__intro">
                                                    {{ stage.passed ? 'Deze check is klaar voor facturatie.' : 'Deze check blokkeert facturatie.' }}
                                                </div>
                                                <div class="ready-tooltip__reason">{{ stage.reason }}</div>
                                                <ul class="ready-tooltip__details" *ngIf="stage.details?.length">
                                                    <li *ngFor="let detail of stage.details">{{ detail }}</li>
                                                </ul>
                                            </div>
                                        </ng-template>
                                    </span>
                                </div>
                            </td>
                            <td mat-footer-cell class="col-readiness dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="department">
                            <th mat-header-cell class="col-department" *matHeaderCellDef mat-sort-header>Department</th>
                            <td mat-cell class="col-department" *matCellDef="let project"><span class="tag"><div>{{ getDepartmentLabel(project) }}</div></span></td>
                            <td mat-footer-cell class="col-department dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="timesheetRequired">
                            <th mat-header-cell class="col-type" *matHeaderCellDef>Time registration type</th>
                            <td mat-cell class="col-type" *matCellDef="let project"><span *ngIf="getTimesheetTypeFor(project)" class="tag tag--blue">{{ getTimesheetTypeFor(project) | uppercase }}</span></td>
                            <td mat-footer-cell class="col-type dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="isBilled">
                            <th mat-header-cell class="col-billed" *matHeaderCellDef mat-sort-header>Has been billed</th>
                            <td mat-cell class="col-billed" *matCellDef="let project">
                                <!-- No Invoice marker: red X, clickable to edit, tooltip shows reason -->
                                <span *ngIf="hasNoInvoice(project)"
                                    (click)="openNoInvoiceDialog(project); $event.stopPropagation()"
                                    [title]="'Geen factuur: ' + getNoInvoiceReason(project) + '\n(klik om te bewerken)'"
                                    style="cursor:pointer; margin-right:4px;">
                                    <i class="las la-times-circle" style="color:#d32f2f; font-size:20px;"></i>
                                </span>
                                <!-- Normal billed state: invoice PDF / Comanage links -->
                                <span id="billed" *ngIf="hasBilledTimeslots(project)">
                                    <i *ngIf="isProjectInvoiceSent(project)"
                                        class="las la-paper-plane"
                                        [title]="'Invoice sent in Comanage'"
                                        style="color:#2e7d32; font-size:18px; margin-right:4px;"></i>
                                    <ng-container *ngIf="getInvoiceItems(project).length > 0; else billedNoPdf">
                                        <ng-container *ngFor="let inv of getInvoiceItems(project)">
                                            <a *ngIf="inv.pdfUrl"
                                                [href]="inv.pdfUrl" target="_blank"
                                                (click)="$event.stopPropagation()"
                                                [title]="'Open factuur PDF ' + inv.number"
                                                style="color:#d32f2f; font-size:18px; text-decoration:none; margin-right:2px;">
                                                <i class="las la-file-pdf"></i>
                                            </a>
                                            <a *ngIf="inv.link"
                                                [href]="inv.link" target="_blank"
                                                (click)="$event.stopPropagation()"
                                                [title]="'Bekijk ' + inv.number + ' in Comanage'"
                                                style="color:#1565c0; font-size:18px; text-decoration:none; margin-right:4px;">
                                                <i class="las la-external-link-alt"></i>
                                            </a>
                                        </ng-container>
                                    </ng-container>
                                    <ng-template #billedNoPdf>
                                        <i class="las la-check-circle billed" style="color: green"></i>
                                    </ng-template>
                                </span>
                            </td>
                            <td mat-footer-cell class="col-billed dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="timeslots">
                            <th mat-header-cell class="col-timeslots" *matHeaderCellDef mat-sort-header>Logged time by Employee</th>
                            <td mat-cell class="col-timeslots" *matCellDef="let project">
                                <div *ngFor="let slot of getTimeslotsForProject(project)">
                                    <app-pill-employee [employee]="getEmployeeByTimeslot(slot)" class="employee-pill"></app-pill-employee>
                                    <span class="displayed-time">: {{ slot.minutes | minutesToMinutesAndHours }} hours ({{ getTotalDaysFromMinutes(slot.minutes) }} days)</span>
                                    <span *ngIf="getEmployeeCostForSlot(slot, project)" class="displayed-time" style="color: #d32f2f;" [title]="getEmployeeCostTooltip(slot, project)"> - {{ getEmployeeCostForSlot(slot, project) }} EUR</span>
                                </div>
                            </td>
                            <td mat-footer-cell class="col-timeslots dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <ng-container matColumnDef="totalHours">
                            <th mat-header-cell class="col-total" *matHeaderCellDef mat-sort-header>Total hours</th>
                            <td mat-cell class="col-total" *matCellDef="let project">{{getTotalWorkedMinutesForProject(project) | minutesToMinutesAndHours }} hours</td>
                            <td mat-footer-cell class="col-total dept-footer" *matFooterCellDef>{{ getDepartmentTotalHoursMinutes(dept.key) | minutesToMinutesAndHours }} hours</td>
                        </ng-container>

                        <ng-container matColumnDef="expectedRevenue">
                            <th mat-header-cell class="col-revenue" *matHeaderCellDef>Verwachte omzet</th>
                            <td mat-cell class="col-revenue" *matCellDef="let project"
                                [title]="getRevenueTooltip(project)">
                                {{ getExpectedRevenueForProject(project) | currency:'EUR':'symbol':'1.0-0' }}
                                <ng-container *ngIf="getRevenueComparison(project) as cmp">
                                    <i *ngIf="cmp === 'match'" class="las la-check-circle" style="color: #2e7d32; margin-left: 4px;" [title]="getRevenueComparisonTooltip(project)"></i>
                                    <i *ngIf="cmp === 'over'" class="las la-arrow-up" style="color: #f57c00; margin-left: 4px;" [title]="getRevenueComparisonTooltip(project)"></i>
                                    <i *ngIf="cmp === 'under'" class="las la-arrow-down" style="color: #d32f2f; margin-left: 4px;" [title]="getRevenueComparisonTooltip(project)"></i>
                                </ng-container>
                            </td>
                            <td mat-footer-cell class="col-revenue dept-footer" *matFooterCellDef>{{ getDepartmentExpectedRevenue(dept.key) | currency:'EUR':'symbol':'1.0-0' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="edit">
                            <th mat-header-cell class="col-edit" *matHeaderCellDef></th>
                            <td mat-cell class="col-edit" *matCellDef="let row">
                                <span ngbDropdown container="body" class="dropdown" *appIsPermitted="{ module: 'TIMESHEETS', operator: 'AND', actions: ['READ'] }">
                                    <button ngbDropdownToggle class="button button--icon button--small dropdown-toggle" (click)="$event.stopPropagation()" title="Invoice actions">
                                    </button>
                                    <span ngbDropdownMenu class="dropdown-menu-right" (click)="$event.stopPropagation()">
                                        <button type="button" ngbDropdownItem (click)="openInvoiceDialog(getTimeslotsForProject(row)); $event.stopPropagation()">Create invoice</button>
                                        <button type="button" ngbDropdownItem (click)="openLinkInvoiceDialog(getTimeslotsForProject(row)); $event.stopPropagation()">Link invoice</button>
                                        <button type="button" ngbDropdownItem (click)="openNoInvoiceDialog(row); $event.stopPropagation()">No invoice</button>
                                        <button type="button" ngbDropdownItem *ngIf="hasNoInvoice(row)" (click)="clearNoInvoice(row); $event.stopPropagation()" style="color: #d32f2f;">Verwijder 'geen factuur'</button>
                                        <button type="button" ngbDropdownItem *ngIf="hasBilledTimeslots(row)" (click)="unlinkInvoice(row); $event.stopPropagation()" style="color: #d32f2f;">Unlink invoice</button>
                                    </span>
                                </span>
                            </td>
                            <td mat-footer-cell class="col-edit dept-footer" *matFooterCellDef></td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns" class="dept-footer-row"></tr>
                        <tr *matNoDataRow>
                            <td colspan="9">No timesheets matching the filter "{{ filter }}"</td>
                        </tr>
                    </table>
                    <!-- Cost & Margin summary below department table -->
                    <div class="dept-cost-margin-summary" style="display: flex; justify-content: flex-end; gap: 24px; padding: 8px 16px; font-size: 13px; border-bottom: 1px solid #e0e0e0; background: #fafafa;">
                        <span [title]="getDepartmentCostTooltip(dept.key)" style="cursor: help;">
                            <strong>Total cost:</strong>
                            <span style="color: #d32f2f;">{{ getDepartmentTotalCost(dept.key) | currency:'EUR':'symbol':'1.0-0' }}</span>
                        </span>
                        <span>
                            <strong>Margin:</strong>
                            <span [style.color]="getDepartmentMargin(dept.key) >= 0 ? '#2e7d32' : '#d32f2f'">
                                {{ getDepartmentMargin(dept.key) | currency:'EUR':'symbol':'1.0-0' }}
                            </span>
                        </span>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <app-loading-message *ngIf="isLoading || sendingReminders"></app-loading-message>
